export default "__VITE_ASSET__DHS_tOKb__"